import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import BreadCrumbMenu from "src/components/breadCrumbMenu/BreadCrumbMenu";

const AppPageContainer = ({ className, children, RightComponent = null }: any) => {
  const breadCrumbsPaths = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const { t } = useTranslation(["common", "user"]);
  return (
    <div className={`wide-main-content-inner pt-4 ${className||''}`}>
      {breadCrumbsPaths.length > 0 && (
        <div className="padding-start-50 padding-end-50">
          <BreadCrumbMenu />
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="inner-page-title">
              {t(breadCrumbsPaths[breadCrumbsPaths.length - 1].label)}
            </h2>
            {RightComponent && <RightComponent />}
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default AppPageContainer;
